module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "ISSA.dd424d68.png";